 // const wheel = document.querySelector("#wheel-section img");
 //    const wheelSection = document.getElementById("wheel-section");

 //    let rotation = 0;
 //    const requiredRotation = 360;
 //    let rotationDone = false;
 //    let hasEntered = false;

 //    // Check if the entire wheel image is fully visible in viewport
 //    function isFullyVisible(elem) {
 //      const rect = elem.getBoundingClientRect();
 //      return (
 //        rect.top >= 0 &&
 //        rect.bottom <= window.innerHeight
 //      );
 //    }

 //    window.addEventListener("scroll", () => {
 //      const fullyVisible = isFullyVisible(wheel);

 //      if (fullyVisible && !hasEntered) {
 //        hasEntered = true;
 //        rotation = 0;
 //        rotationDone = false;
 //        wheel.style.transform = `rotate(0deg)`;
 //      }

 //      if (!fullyVisible) {
 //        hasEntered = false;
 //      }
 //    });

 //    window.addEventListener("wheel", (e) => {
 //      if (!isFullyVisible(wheel)) return;
 //      if (rotationDone) return;

 //      e.preventDefault();

 //      const delta = e.deltaY;

 //      if (delta > 0) {
 //        rotation += 5; // scroll down
 //      } else {
 //        rotation -= 5; // scroll up
 //      }

 //      // Clamp rotation
 //      if (rotation > requiredRotation) rotation = requiredRotation;
 //      if (rotation < -requiredRotation) rotation = -requiredRotation;

 //      wheel.style.transform = `rotate(${rotation}deg)`;

 //      if (Math.abs(rotation) >= requiredRotation) {
 //        rotationDone = true;
 //      }
 //    }, { passive: false });

// when wheel is fully visible it lock the screen and continue when when rotation is complete
// const wheel = document.querySelector("#wheel-section img");

//     let rotation = 0;
//     const requiredRotation = 360;

//     let rotationDone = false;
//     let isFullyVisibleNow = false;
//     let hasInitializedRotation = false;

//     function isFullyVisible(elem) {
//       const rect = elem.getBoundingClientRect();
//       return rect.top >= 0 && rect.bottom <= window.innerHeight;
//     }

//     window.addEventListener("scroll", () => {
//       const fullyVisible = isFullyVisible(wheel);

//       // When wheel becomes fully visible, reset rotation
//       if (fullyVisible && !isFullyVisibleNow) {
//         isFullyVisibleNow = true;
//         rotation = 0;
//         rotationDone = false;
//         hasInitializedRotation = false;
//         // Don't apply transform here to avoid jerk
//       }

//       if (!fullyVisible && isFullyVisibleNow) {
//         isFullyVisibleNow = false;
//       }
//     });

//     window.addEventListener("wheel", (e) => {
//       if (!isFullyVisible(wheel)) return;
//       if (rotationDone) return;

//       e.preventDefault();

//       // On first scroll interaction, apply the reset visually
//       if (!hasInitializedRotation) {
//         wheel.style.transform = `rotate(0deg)`;
//         hasInitializedRotation = true;
//       }

//       const delta = e.deltaY;

//       if (delta > 0) {
//         rotation += 5; // clockwise
//       } else {
//         rotation -= 5; // counterclockwise
//       }

//       // Clamp rotation
//       if (rotation > requiredRotation) rotation = requiredRotation;
//       if (rotation < -requiredRotation) rotation = -requiredRotation;

//       wheel.style.transform = `rotate(${rotation}deg)`;

//       if (Math.abs(rotation) >= requiredRotation) {
//         rotationDone = true;
//       }
//     }, { passive: false });
// ---------------------------------------------
  //  const section = document.getElementById("shopify-section-template--24689031020916__media-with-text");
  // const wheel = section.querySelector("img");

  // let rotation = 0;

  // function isPartiallyVisible(elem) {
  //   const rect = elem.getBoundingClientRect();
  //   return rect.bottom > 0 && rect.top < window.innerHeight;
  // }

  // window.addEventListener("wheel", (e) => {
  //   if (!isPartiallyVisible(wheel)) return;

  //   const delta = e.deltaY;
  //   rotation += delta > 0 ? 5 : -5; // down = clockwise, up = counterclockwise
  //   wheel.style.transform = `rotate(${rotation}deg)`;
  // }, { passive: true });

const section = document.getElementById("firstsection-template--26430530486644__media_with_text_rJjaab");
const wheel = section.querySelector("img");

let currentRotation = 0;
let targetRotation = 0;
let isAnimating = false;

function isPartiallyVisible(elem) {
  const rect = elem.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

function animateRotation() {
  const ease = 0.1; // faster easing
  const diff = targetRotation - currentRotation;

  if (Math.abs(diff) > 0.01) {
    currentRotation += diff * ease;
    wheel.style.transform = `rotate(${currentRotation}deg)`;
    requestAnimationFrame(animateRotation);
  } else {
    isAnimating = false;
  }
}

window.addEventListener("wheel", (e) => {
  if (!isPartiallyVisible(wheel)) return;

  const delta = e.deltaY;
  targetRotation += delta * 0.3; // more responsive scroll

  if (!isAnimating) {
    isAnimating = true;
    animateRotation();
  }
}, { passive: true });

